import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a41eba5e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12 ModelField-colSingle" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Скопировать данные из", -1))
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-6 ModelField-colFirst" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Наименование", -1))
const _hoisted_8 = {
  key: 0,
  class: "col-6 ModelField-colLast"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Заказ", -1))
const _hoisted_10 = { class: "card card-body" }
const _hoisted_11 = { class: "container-fluid" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-6 ModelField-colFirst" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Длина (мм)", -1))
const _hoisted_15 = { class: "col-6 ModelField-colLast" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Ширина (мм)", -1))
const _hoisted_17 = { class: "row" }
const _hoisted_18 = { class: "col-6 ModelField-colFirst" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Высота (мм)", -1))
const _hoisted_20 = { class: "col-6 ModelField-colLast" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Высота в центре (мм)", -1))
const _hoisted_22 = { class: "row" }
const _hoisted_23 = { class: "col-4 ModelField-colFirst" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Ширина дверного проема (мм)", -1))
const _hoisted_25 = { class: "col-4 ModelField-col" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Толщина дверного проема (мм)", -1))
const _hoisted_27 = { class: "col-4 ModelField-colLast" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Высота дверного проема (мм)", -1))
const _hoisted_29 = { class: "row" }
const _hoisted_30 = { class: "col-6 ModelField-colFirst" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Грузоподъемность (кг)", -1))
const _hoisted_32 = { class: "col-6 ModelField-colLast" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Кубатура (объем)", -1))
const _hoisted_34 = { class: "row" }
const _hoisted_35 = { class: "col-6 ModelField-colFirst" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Отступы", -1))
const _hoisted_37 = { class: "col-6 ModelField-colLast" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Количество (шт)", -1))
const _hoisted_39 = { class: "card card-body Container-card" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "card-title Container-title" }, " Данные для расчета допустимого смещения ", -1))
const _hoisted_41 = { class: "container-fluid" }
const _hoisted_42 = { class: "row" }
const _hoisted_43 = { class: "col-6 ModelField-colFirst" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, " Высота уровня настила пола (мм) ", -1))
const _hoisted_45 = { class: "col-6 ModelField-colLast" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, " Допускаемое смещение общего ЦТ груза в транспорте ", -1))
const _hoisted_47 = { class: "row" }
const _hoisted_48 = { class: "col-6 ModelField-colFirst" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, " Вес порожнего транспортного средства (кг) ", -1))
const _hoisted_50 = { class: "col-6 ModelField-colLast" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, " Высота ЦТ порожнего транспортного средства (мм) ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CatalogueSelectControl = _resolveComponent("CatalogueSelectControl")!
  const _component_TextControl = _resolveComponent("TextControl")!
  const _component_IntegerControl = _resolveComponent("IntegerControl")!
  const _component_DecimalControl = _resolveComponent("DecimalControl")!
  const _component_CreateEditDialog = _resolveComponent("CreateEditDialog")!

  return (_openBlock(), _createBlock(_component_CreateEditDialog, {
    saveModelCallback: _ctx.saveModelCallback,
    maxWidth: "1000px",
    ref: "dialog"
  }, {
    editForm: _withCtx(({ model, validationGroup }) => [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createVNode(_component_CatalogueSelectControl, {
                class: "ModelField-selectControl",
                stylingMode: "outlined",
                id: model.transportBoxCarId,
                "onUpdate:id": ($event: any) => ((model.transportBoxCarId) = $event),
                desc: model.transportBoxCarDescription,
                "onUpdate:desc": ($event: any) => ((model.transportBoxCarDescription) = $event),
                keyField: "id",
                displayDescField: "name",
                catalogueComponentName: "catalogues/TransportCatalogue/TransportBoxCarCatalogue",
                hasEmptyValue: true,
                validationGroup: validationGroup,
                onChanged: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onChange()))
              }, null, 8, ["id", "onUpdate:id", "desc", "onUpdate:desc", "validationGroup"])
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createVNode(_component_TextControl, {
                class: "ModelField-control",
                stylingMode: "outlined",
                placeholder: "Наименование...",
                "show-clear-button": true,
                value: model.name,
                "onUpdate:value": ($event: any) => ((model.name) = $event),
                hasEmptyValue: false,
                validationGroup: validationGroup
              }, null, 8, ["value", "onUpdate:value", "validationGroup"])
            ]),
            (_ctx.hasOrder)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _hoisted_9,
                  _createVNode(_component_TextControl, {
                    class: "ModelField-control",
                    stylingMode: "outlined",
                    placeholder: "Заказ...",
                    "show-clear-button": true,
                    value: model.orderDescription,
                    "onUpdate:value": ($event: any) => ((model.orderDescription) = $event),
                    hasEmptyValue: false,
                    validationGroup: validationGroup
                  }, null, 8, ["value", "onUpdate:value", "validationGroup"])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _createVNode(_component_IntegerControl, {
                  class: "ModelField-control",
                  stylingMode: "outlined",
                  placeholder: "Длина...",
                  min: 0,
                  value: model.length,
                  "onUpdate:value": ($event: any) => ((model.length) = $event),
                  hasEmptyValue: false,
                  validationGroup: validationGroup
                }, null, 8, ["value", "onUpdate:value", "validationGroup"])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _createVNode(_component_IntegerControl, {
                  class: "ModelField-control",
                  stylingMode: "outlined",
                  placeholder: "Ширина...",
                  min: 0,
                  value: model.width,
                  "onUpdate:value": ($event: any) => ((model.width) = $event),
                  hasEmptyValue: false,
                  validationGroup: validationGroup
                }, null, 8, ["value", "onUpdate:value", "validationGroup"])
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                _createVNode(_component_IntegerControl, {
                  class: "ModelField-control",
                  stylingMode: "outlined",
                  placeholder: "Высота...",
                  min: 0,
                  value: model.height,
                  "onUpdate:value": ($event: any) => ((model.height) = $event),
                  hasEmptyValue: false,
                  validationGroup: validationGroup
                }, null, 8, ["value", "onUpdate:value", "validationGroup"])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _hoisted_21,
                _createVNode(_component_IntegerControl, {
                  class: "ModelField-control",
                  stylingMode: "outlined",
                  placeholder: "Высота в центре...",
                  min: 0,
                  value: model.centerHeight,
                  "onUpdate:value": ($event: any) => ((model.centerHeight) = $event),
                  hasEmptyValue: false,
                  validationGroup: validationGroup
                }, null, 8, ["value", "onUpdate:value", "validationGroup"])
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _hoisted_24,
                _createVNode(_component_IntegerControl, {
                  class: "ModelField-control",
                  stylingMode: "outlined",
                  placeholder: "Ширина дверного проема...",
                  min: 0,
                  value: model.doorWidth,
                  "onUpdate:value": ($event: any) => ((model.doorWidth) = $event),
                  hasEmptyValue: false,
                  validationGroup: validationGroup
                }, null, 8, ["value", "onUpdate:value", "validationGroup"])
              ]),
              _createElementVNode("div", _hoisted_25, [
                _hoisted_26,
                _createVNode(_component_IntegerControl, {
                  class: "ModelField-control",
                  stylingMode: "outlined",
                  placeholder: "Толщина дверного проема...",
                  min: 0,
                  value: model.doorThickness,
                  "onUpdate:value": ($event: any) => ((model.doorThickness) = $event),
                  hasEmptyValue: false,
                  validationGroup: validationGroup
                }, null, 8, ["value", "onUpdate:value", "validationGroup"])
              ]),
              _createElementVNode("div", _hoisted_27, [
                _hoisted_28,
                _createVNode(_component_IntegerControl, {
                  class: "ModelField-control",
                  stylingMode: "outlined",
                  placeholder: "Высота дверного проема...",
                  min: 0,
                  value: model.doorHeight,
                  "onUpdate:value": ($event: any) => ((model.doorHeight) = $event),
                  hasEmptyValue: false,
                  validationGroup: validationGroup
                }, null, 8, ["value", "onUpdate:value", "validationGroup"])
              ])
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _hoisted_31,
                _createVNode(_component_DecimalControl, {
                  class: "ModelField-control",
                  stylingMode: "outlined",
                  placeholder: "Грузоподъемность...",
                  decimalPoints: 2,
                  min: 0,
                  value: model.loadCapacity,
                  "onUpdate:value": ($event: any) => ((model.loadCapacity) = $event),
                  hasEmptyValue: false,
                  validationGroup: validationGroup
                }, null, 8, ["value", "onUpdate:value", "validationGroup"])
              ]),
              _createElementVNode("div", _hoisted_32, [
                _hoisted_33,
                _createVNode(_component_DecimalControl, {
                  class: "ModelField-control",
                  stylingMode: "outlined",
                  placeholder: "Кубатура...",
                  decimalPoints: 2,
                  min: 0,
                  value: model.volume,
                  "onUpdate:value": ($event: any) => ((model.volume) = $event),
                  hasEmptyValue: false,
                  validationGroup: validationGroup
                }, null, 8, ["value", "onUpdate:value", "validationGroup"])
              ])
            ]),
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("div", _hoisted_35, [
                _hoisted_36,
                _createVNode(_component_CatalogueSelectControl, {
                  class: "ModelField-selectControl",
                  stylingMode: "outlined",
                  id: model.gapId,
                  "onUpdate:id": ($event: any) => ((model.gapId) = $event),
                  desc: model.gapDescription,
                  "onUpdate:desc": ($event: any) => ((model.gapDescription) = $event),
                  displayDescField: "name",
                  keyField: "id",
                  catalogueComponentName: "catalogues/GapCatalogue/GapCatalogue",
                  hasEmptyValue: false,
                  validationGroup: validationGroup
                }, null, 8, ["id", "onUpdate:id", "desc", "onUpdate:desc", "validationGroup"])
              ]),
              _createElementVNode("div", _hoisted_37, [
                _hoisted_38,
                _createVNode(_component_IntegerControl, {
                  class: "ModelField-control",
                  stylingMode: "outlined",
                  placeholder: "Количество...",
                  min: 0,
                  value: model.planCount,
                  "onUpdate:value": ($event: any) => ((model.planCount) = $event),
                  hasEmptyValue: false,
                  validationGroup: validationGroup
                }, null, 8, ["value", "onUpdate:value", "validationGroup"])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_39, [
          _hoisted_40,
          _createElementVNode("div", _hoisted_41, [
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("div", _hoisted_43, [
                _hoisted_44,
                _createVNode(_component_IntegerControl, {
                  class: "ModelField-control",
                  stylingMode: "outlined",
                  placeholder: "Высота уровня настила пола...",
                  min: 0,
                  value: model.heightOverLevelRailHead,
                  "onUpdate:value": ($event: any) => ((model.heightOverLevelRailHead) = $event),
                  hasEmptyValue: false,
                  validationGroup: validationGroup
                }, null, 8, ["value", "onUpdate:value", "validationGroup"])
              ]),
              _createElementVNode("div", _hoisted_45, [
                _hoisted_46,
                _createVNode(_component_CatalogueSelectControl, {
                  class: "ModelField-selectControl",
                  stylingMode: "outlined",
                  id: model.displacementId,
                  "onUpdate:id": ($event: any) => ((model.displacementId) = $event),
                  desc: model.displacementDescription,
                  "onUpdate:desc": ($event: any) => ((model.displacementDescription) = $event),
                  displayDescField: "name",
                  keyField: "id",
                  catalogueComponentName: "catalogues/DisplacementCatalogue/DisplacementCatalogue",
                  hasEmptyValue: false,
                  validationGroup: validationGroup
                }, null, 8, ["id", "onUpdate:id", "desc", "onUpdate:desc", "validationGroup"])
              ])
            ]),
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("div", _hoisted_48, [
                _hoisted_49,
                _createVNode(_component_DecimalControl, {
                  class: "ModelField-control",
                  stylingMode: "outlined",
                  placeholder: "Вес порожнего ТС...",
                  decimalPoints: 2,
                  min: 0,
                  value: model.weight,
                  "onUpdate:value": ($event: any) => ((model.weight) = $event),
                  hasEmptyValue: false,
                  validationGroup: validationGroup
                }, null, 8, ["value", "onUpdate:value", "validationGroup"])
              ]),
              _createElementVNode("div", _hoisted_50, [
                _hoisted_51,
                _createVNode(_component_IntegerControl, {
                  class: "ModelField-control",
                  stylingMode: "outlined",
                  placeholder: "Высота ЦТ порожнего ТС...",
                  min: 0,
                  value: model.heightCenterMass,
                  "onUpdate:value": ($event: any) => ((model.heightCenterMass) = $event),
                  hasEmptyValue: false,
                  validationGroup: validationGroup
                }, null, 8, ["value", "onUpdate:value", "validationGroup"])
              ])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["saveModelCallback"]))
}